import React from 'react';
import styled from 'styled-components';

export default function Building() {
  return <Image src="/assets/building.gif" alt="Em Breve" />;
}

const Image = styled.img`
  width: 100vw;
  margin: 0 auto;
`;
